module.exports = __webpack_public_path__ + "img/Specom-GT.d99f96cc.png";